/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useMediaQuery, useTheme } from "@mui/material";
import dayjs from "dayjs";
import { memo } from "react";

import { ItemContainer, ItemValue } from "../../../../components/styled";
import TestIds from "../../../../testIds";
import { SideContainer } from "../../../products/components/ProductCard/SideContainer";

const CreatedAt = ({ createdAt }: { createdAt: Date | string }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const renderedItem = (
    <ItemContainer wrap={isSmall}>
      <ItemValue
        variant={"caption"}
        align={"right"}
        data-testid={TestIds.feat.quotes.card.expiryDate}
      >
        Created {dayjs(createdAt).format("DD MMM YYYY")}
      </ItemValue>
    </ItemContainer>
  );

  if (isSmall) {
    return renderedItem;
  }

  return <SideContainer sx={{ m: 0, ml: "auto" }}>{renderedItem}</SideContainer>;
};

export const QuoteCreatedAt = memo(CreatedAt);
